export const AUTH_TOKEN = "Tomcat_auth_token";
export const AUTH_PROFILE = "Tomcat_auth_profile";
